import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['email', 'emailError']
  static values = { blankMessage: String, malformedMessage: String, emailPattern: String, minEmailLength: Number }

  validateEmail(event) {
    if (this.emailTarget.readOnly) return

    // Normalized like User.strip_username, then the same regex + minimum length as User.malformed_login_email?. The
    // max length, Mail parse and account lookup stay server-side, which is authoritative.
    const message = this.errorMessage(this.emailTarget.value.trim().toLowerCase().replaceAll(' ', ''))
    if (message) {
      event.preventDefault()
      this.emailErrorTarget.textContent = message
      this.emailErrorTarget.classList.remove('hidden')
      this.emailTarget.setAttribute('aria-invalid', 'true')
      this.emailTarget.setAttribute('aria-describedby', this.emailErrorTarget.id)
      this.emailTarget.focus()
    } else {
      this.clearError()
    }
  }

  errorMessage(login) {
    if (login === '') return this.blankMessageValue
    if (login.includes('@') && !this.wellFormedEmail(login)) return this.malformedMessageValue
    return null
  }

  wellFormedEmail(login) {
    return login.length >= this.minEmailLengthValue && new RegExp(`^${this.emailPatternValue}$`).test(login)
  }

  clearError() {
    this.emailErrorTarget.classList.add('hidden')
    this.emailTarget.removeAttribute('aria-invalid')
    this.emailTarget.removeAttribute('aria-describedby')
  }
}
